import { createRouter, createWebHistory } from 'vue-router';
import MainLayout from '../views/layouts/siteLayouts/MainLayout.vue';
// import store from '../store/index.js';
import HomePage from '../views/Home.vue';
import About from '../views/About.vue';
import ContactUs from '../views/ContactUs.vue';
import Articles from '../views/site/Articles.vue';
import QuestionAnswers from '../views/site/QuestionAnswers.vue';
import ArticleView from '../views/site/ArticleView.vue';
import QuestionAnswerView from '../views/site/QuestionAnswerView.vue';
//import Login from '../views/authentication/Login.vue';
import Login from '../views/authentication/Login.vue';
import TestOTP from '../views/authentication/TestOTP.vue';
import Panel from '../views/site/Panel.vue';
import NotFound from '../views/NotFound.vue';
import Unauthorize from '../views/Unauthorize.vue';
import UsingComponentEX from '../views/UsingComponentEX.vue';
import ReservingSessionTab from '../views/site/panel/reservingSessionTab/ReservingSessionTab.vue';
import SessionsTab from '../views/site/panel/sessionsTab/SessionsTab.vue';
import WalletTab from '../views/site/panel/walletTab/WalletTab.vue';
import ViolationReportTab from '../views/site/panel/violationReportTab/ViolationReportTab.vue';
import UserProfileTab from '../views/site/panel/userProfileTab/UserProfileTab.vue';
import MessagesTab from '../views/site/panel/messagesTab/MessagesTab.vue';
import EmergencySessionTab from '../views/site/panel/emergencySessionTab/EmergencySessionTab.vue';
import FAQ from '../views/site/FAQ.vue';
import SelectTherapist from '../views/site/panel/reservingSessionTab/selectTherapist/SelectTherapist.vue';
import SelectTestSession from '../views/site/panel/reservingSessionTab/selectTestSession/SelectTestSession.vue';
import FilteringMore from '../views/site/panel/reservingSessionTab/filteringMore/FilteringMore.vue';
import SessionTableView from '../views/site/panel/reservingSessionTab/sessionTableView/SessionTableView.vue';
import FinalConfirm from '../views/site/panel/reservingSessionTab/finalConfirm/FinalConfirm.vue';
import InvoiceList from '../views/site/panel/reservingSessionTab/invoiceList/InvoiceList.vue';
import UserPanel from '../views/site/panel/userPanelTab/UserPanel.vue';
import WorkshopTab from '../views/site/panel/workshopTab/WorkshopTab.vue';
import WorkshopView from '../views/site/panel/workshopTab/WorkshopView.vue';
import WorkshopInvoice from '../views/site/panel/workshopTab/WorkshopInvoice.vue';

import DiscountCodeTab from '../views/site/panel/discountCodeTab/DiscountCodeTab.vue';

const routes = [
  {
    path: '/',
    name: 'mainLayout',
    component: MainLayout,
    children: [
      {
        path: '/',
        name: 'home',
        component: HomePage,
      },
      {
        path: '/about',
        name: 'about',
        component: About,
      },
      {
        path: '/contactUs',
        name: 'contactUs',
        component: ContactUs,
      },

      {
        path: '/faq',
        name: 'faq',
        component: FAQ,
      },

      {
        path: '/articles',
        name: 'articles',
        component: Articles,
      },
      {
        path: '/ArticleView/:id',
        name: 'ArticleView',
        component: ArticleView,
      },
      {
        path: '/questionAnswers',
        name: 'questionAnswers',
        component: QuestionAnswers,
      },
      {
        path: '/login',
        name: 'login',
        component: Login,
        // props: true,
      },
      // {
      //   path: '/newlogin',
      //   name: 'newlogin',
      //   component: NewLogin,
      //   // props: true,
      // },
      {
        path: '/testOTP',
        name: 'testOTP',
        component: TestOTP,
        // props: true,
      },

      {
        path: '/questionAnswerView/:id',
        name: 'questionAnswerView',
        component: QuestionAnswerView,
      },

      {
        path: '/panel',
        name: 'panel',
        component: Panel,
        children: [
          {
            path: '/:id',
            name: 'reservingSessionTab',
            component: ReservingSessionTab,
            children: [
              {
                path: '/panel/reservingSessionTab/selectTherapist/:id',
                name: 'selectTherapist',
                component: SelectTherapist,
              },
              {
                path: '/panel/reservingSessionTab/filteringMore/:id',
                name: 'filteringMore',
                component: FilteringMore,
              },
              {
                path: '/panel/reservingSessionTab/sessionTableView/:id',
                name: 'sessionTableView',
                component: SessionTableView,
              },
              {
                path: '/panel/reservingSessionTab/finalConfirm/:id',
                name: 'finalConfirm',
                component: FinalConfirm,
              },
              {
                path: '/panel/reservingSessionTab/invoiceList/:id',
                name: 'invoiceList',
                component: InvoiceList,
              },
            ],
          },
          {
            path: '/:id',
            name: 'reservingSessionTestTab',
            component: ReservingSessionTab,
            children: [
              {
                path: '/panel/reservingSessionTestTab/selectTestSession/:id',
                name: 'selectTestSession',
                component: SelectTestSession,
              },
              {
                path: '/panel/reservingSessionTestTab/sessionTableViewByTest/:id',
                name: 'sessionTableViewByTest',
                component: SessionTableView,
              },
              {
                path: '/panel/reservingSessionTestTab/finalConfirmByTest/:id',
                name: 'finalConfirmByTest',
                component: FinalConfirm,
              },
            ],
          },
          {
            path: '/panel/sessionsTab/:id',
            name: 'sessionsTab',
            component: SessionsTab,
          },
          {
            path: '/panel/walletTab/:id',
            name: 'walletTab',
            component: WalletTab,
          },
          {
            path: '/panel/workshopTab/:id/:type',
            name: 'workshopTab',
            component: WorkshopTab,
          },
          {
            path: '/panel/workshopView/:id',
            name: 'workshopView',
            component: WorkshopView,
          },
          {
            path: '/panel/workshopInvoice/:id',
            name: 'workshopInvoice',
            component: WorkshopInvoice,
          },

          {
            path: '/panel/violationReportTab/:id',
            name: 'violationReportTab',
            component: ViolationReportTab,
          },
          {
            path: '/panel/userProfileTab/:id',
            name: 'userProfileTab',
            component: UserProfileTab,
          },
          {
            path: '/panel/messagesTab/:id',
            name: 'messagesTab',
            component: MessagesTab,
          },
          {
            path: '/panel/emergencySessionTab/:id',
            name: 'emergencySessionTab',
            component: EmergencySessionTab,
          },
          {
            path: '/panel/userPanel/:id?',
            name: 'userPanel',
            component: UserPanel,
          },

          {
            path: '/panel/discountCode/:id?',
            name: 'discountCode',
            component: DiscountCodeTab,
          },
        ],
      },
      {
        path: '/unauthorize',
        name: 'unauthorize',
        component: Unauthorize,
      },
      {
        path: '/notFound',
        name: 'notFound',
        component: NotFound,
      },
    ],
  },
  {
    path: '/usingComponentEX',
    name: 'usingComponentEX',
    component: UsingComponentEX,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
